.ZaiChatMobilePageView {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  .ZaiChatMobilePageView-content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    padding: 16px;
  }

  .ZaiChatMobilePageView-title {
    font-size: 16px;
    font-weight: 700;
    color: var(--color_neutral_800);
  }

  .ZaiChatMobilePageView-body {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    flex: 1;

    & > button {
      padding: 4px 8px 4px 4px;

      svg {
        flex: none;
      }
    }
  }

  .ZaiChatMobilePageView-footer {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
}
